<div id="general" class="category-content active">
    <div class="stats-grid">
        <div class="stat-card">
            <span class="stat-number">74</span>
            <div class="stat-label">Jugadores Inscritos</div>
        </div>
        <div class="stat-card">
            <span class="stat-number">9</span>
            <div class="stat-label">Categorias</div>
        </div>
        <div class="stat-card">
            <span class="stat-number">6</span>
            <div class="stat-label">Clubes</div>
        </div>
    </div>

    <div class="rules-grid">
        <div class="rule-card">
            <div>
                <svg width="80px" height="80px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 17V11" stroke="#ff6b35" stroke-width="1.5" stroke-linecap="round" />
                    <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="#ff6b35" />
                    <path
                        d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
                        stroke="#ff6b35" stroke-width="1.5" stroke-linecap="round" />
                </svg>
            </div>
            <div class="rule-list">
                <ul>
                    <li>Todos los partidos se jugarán a 2 de 3 games.</li>
                    <li>Uso de gafas es obligatorio</li>
                    <li>El buen comportamiento es fundamental para el buen desarrollo del torneo la buena conducta deportiva hace que nuestro deporte sea más sano y familiar tanto para deportistas como padres de familia o acompañantes</li>
                    <li>La programación está diseñada por bloques de horas, por favor llegar puntual a sus partidos (los jugadores deben asegurar presencia en el rango de la categoría que le corresponde). </li>
                </ul>
            </div>
        </div>
    </div>

    <h3 style="margin-bottom: 20px; color: #ff6b35; text-align: center;">Programación por bloques</h3>

    <div class="tab-content" style="display: block; margin-bottom: 2rem;">
        <div class="info-schedule">
            <h3 style="margin-bottom: 20px; color: #ff6b35;">Lunes 16 de Febrero</h3>
            <div class="info">
                <div class="time"><span>desde</span>05:00 p.m. <br><span>hasta</span>06:00 p.m.</div>
                <div class="players">Juvenil - Infantil</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>05:00 p.m. <br><span>hasta</span>06:00 p.m.</div>
                <div class="players">Sexta A - B</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>06:00 p.m. <br><span>hasta</span>07:00 p.m.</div>
                <div class="players">Damas - Novatos</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>07:00 p.m. <br><span>hasta</span>08:00 p.m.</div>
                <div class="players">Tercera</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>08:00 p.m. <br><span>hasta</span>09:00 p.m.</div>
                <div class="players">Cuarta</div>
            </div>
        </div>

        <div class="info-schedule">
            <h3 style="margin-bottom: 20px; color: #ff6b35;">Martes 17 de Febrero</h3>
            <div class="info">
                <div class="time"><span>desde</span>05:00 p.m. <br><span>hasta</span>06:00 p.m.</div>
                <div class="players">Juvneil - Cuarta</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>05:00 p.m. <br><span>hasta</span>06:00 p.m.</div>
                <div class="players">Tercera</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>06:00 p.m. <br><span>hasta</span>07:00 p.m.</div>
                <div class="players">Quinta</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>06:00 p.m. <br><span>hasta</span>07:30 p.m.</div>
                <div class="players">Primera</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>07:30 p.m. <br><span>hasta</span>09:00 p.m.</div>
                <div class="players">Novatos (A - B) - Sexta</div>
            </div>
        </div>

        <div class="info-schedule">
            <h3 style="margin-bottom: 20px; color: #ff6b35;">Miércoles 18 de Febrero</h3>
            <div class="info">
                <div class="time"><span>desde</span>05:00 p.m. <br><span>hasta</span>06:00 p.m.</div>
                <div class="players">Quinta</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>06:00 p.m. <br><span>hasta</span>07:00 p.m.</div>
                <div class="players">Primera - Damas</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>06:30 p.m. <br><span>hasta</span>07:30 p.m.</div>
                <div class="players">Novatos C</div>
            </div>
        </div>

        <div class="info-schedule">
            <h3 style="margin-bottom: 20px; color: #ff6b35;">Jueves 19 de Febrero</h3>
            <div class="info">
                <div class="time"><span>desde</span>05:00 p.m.</div>
                <div class="players">Semifinal: Primera</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>05:00 p.m.</div>
                <div class="players">Final: Juvenil - Infantil</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>05:00 p.m.</div>
                <div class="players">Cuartos: Novatos - Cuarta - Quinta</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>06:00 p.m.</div>
                <div class="players">Semifinal: Tercera - Cuarta - Quinta - Sexta - Novatos</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>06:00 p.m.</div>
                <div class="players">Final: Damas</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>07:00 p.m.</div>
                <div class="players">Final: Primera - Cuarta - Quinta - Novatos</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>07:30 p.m.</div>
                <div class="players">Final: Sexta - Tercera</div>
            </div>
        </div>
    </div>
</div>
